import { Card, Skeleton, Stack } from "@mui/material";

/**
 * Placeholder rows shown while a table's data loads - keeps layout stable
 * and reads as "loading" without a spinner jump.
 */
export function TableSkeleton({
  rows = 6,
  showHeader = true,
}: {
  rows?: number;
  showHeader?: boolean;
}) {
  return (
    <Card sx={{ p: 2 }}>
      <Stack spacing={1.25}>
        {showHeader && (
          <Skeleton variant="rounded" height={28} sx={{ mb: 0.5 }} />
        )}
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} variant="rounded" height={40} />
        ))}
      </Stack>
    </Card>
  );
}

export default TableSkeleton;
